(function(callback){
    // Check if jQuery is defined
    if (typeof jQuery === 'undefined') {
        // Load jQuery from CDN
        var script = document.createElement('script');
        script.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
        script.type = 'text/javascript';
        script.onload = callback; // run code after jQuery loads
        document.getElementsByTagName('head')[0].appendChild(script);
    } else {
        // jQuery already loaded
        callback();
    }
})(function(){
    console.log('jQuery loaded');
    // Normalize phone (digits only)
    function normalizePhone(phone) {
        return phone.replace(/\D/g, '');
    }

});

async function validateHelmet() {
    console.log('validate function');
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const freeHelmetVariants = [
    45028077142192,
    45028077174960,
    45028077207728
    ];

    // Check if cart has any limited edition bike
    const hasLimitedBike = cart.items.some(item =>
      item.product_title.toLowerCase().includes('limited edition')
    );

    if (!hasLimitedBike) {
      const updates = {};

      cart.items.forEach(item => {
        // Target the free helmet
        console.log('PRODUCT TITLES' + item.product_title);
        if (freeHelmetVariants.includes(item.variant_id)) {
            updates[item.key] = 0; // remove only the free helmet
        }
      });

      if (Object.keys(updates).length > 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });

        // Reload or re-render cart drawer
        location.reload(); 
      }
    }
  } catch (err) {
    console.error('Helmet validation error:', err);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  validateHelmet();
});